import React from 'react';
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import FormAssembly from "../../components/FormAssembly/FormAssembly";
import store from "../../store";
import {Helmet} from "react-helmet";

const additionalLocationRequestForm = () => {
  return (
    <div className="wrapper">
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                    return row.rowTitle === "Manage" ? row.sections.map((section) => {
                        return section.title === "Forms & Applications" ? section.subsections.map((subsection) => {
                                    return subsection.title === "Additional Location Request Form" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                                })
                                : null
                    }) : null
                }) : null
            }
        </Helmet>
      <Breadcrumbs/>
      <h1 className="two-three-rows__title">Additional Location Request Form</h1>
      <div className="iframe-box-wrapper">
        <FormAssembly formReferenceName="ADDITIONAL_LOCATION_REQUEST_FORM"/>
      </div>
    </div>
  );
};

export default additionalLocationRequestForm;



// WEBPACK FOOTER //
// ./src/pages/manage/AdditionalLocationRequestForm.js